import React from 'react';
import { MaintenanceBanner } from '@/components/MaintenanceBanner';

const GeneralRestrictions: React.FC = () => {
  return (
    <MaintenanceBanner 
      title="Restrictions Coming Soon"
      message="Content and behavior restrictions settings will be available in a future update."
    />
  );
};

export default GeneralRestrictions;
